export default __webpack_public_path__ + "static/media/hedgeTrimming.37d81c93.jpg";